import React, { useEffect, useState } from "react";
import "./home.css";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
//components
import Hero from "../../components/Hero";
import ActivityTypes from "../../components/ActivityTypes";
import TrendingThemes from "../../components/TrendingThemes";
import Messages from "../../components/Messages";
import ActivityCategories from "../../components/ActivityCategories";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Home = () => {
  const [heroOverlayActive, setheroOverlayActive] = useState(true);
  const { width, height } = useWindowDimensions();
  const [footerTopPos, setFooterTopPos] = useState(0);

  const { categories } = useSelector((state) => state.activityCategories);
  const { activityTypes } = useSelector((state) => state.activityTypes);
  const { isLoggedIn } = useSelector((state) => state.user);

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    // localStorage.removeItem('userActivities')
    // localStorage.removeItem('duonutSettings')

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const pageVariants = {
    initial: { y: "100%" },
    in: { y: 0 },
    out: { y: "100%" },
  };

  const pageTransition = {
    duration: 0.4,
  };

  return (
    <div className="home_page" id={width < 1275 && heroOverlayActive ? "hero_overlay-active" : ""}>
      <Hero setheroOverlayActive={setheroOverlayActive} />

      <ActivityCategories />
      {categories.length >= 1 && <ActivityTypes />}

      <TrendingThemes setFooterTopPos={setFooterTopPos} />
      <Messages />
      <AnimatePresence>
        {scrollPosition > footerTopPos - height && (
          <motion.div initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition} className="home_page__btn_container">
            <Link to="/design" target={isLoggedIn ? "" : "_blank"}>
              <button className="btn-primary start-creating-btn">Start Creating</button>
            </Link>
          </motion.div>
        )}
      </AnimatePresence>

      <Link to="/design" target={isLoggedIn ? "" : "_blank"}>
        <div className="add_duonut_icon">
          <img src="/assets/icons/add-duonut.svg" />
        </div>
      </Link>
      <div className="duonut_bottom">
        <div className="duonut_bottom__wrapper d-flex center-y">
          <p>Create a</p>
          <img src="/assets/logo.png" className="logo" />
          {/* <img src='/assets/icons/duonut-bottom.svg' /> */}
        </div>
      </div>
    </div>
  );
};

export default Home;
